import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const getMessages = async (customerId, teamId, userId) => {
    const settings = {
      headers: {
        'Authorization': `Bearer ${getAccessToken()}`
      }
    };

    let data = {}

    if (customerId) {
        data.customer_ids = [customerId];
    }

    if (teamId) {
        data.team_ids = [teamId];
    }

    if (userId) {
        data.user_id = userId;
    }

    return axios.post(`${BASE_URL}/api/message-center`, data, settings);
}

export const messageSeen = async (message) => {
    const settings = {
      headers: {
        'Authorization': `Bearer ${getAccessToken()}`
      }
    };

    return axios.patch(`${BASE_URL}/api/message-center/seen?message_id=${message.id}`, null, settings);
}
